import { Context } from "Context";
import { useContext, useState } from "react";
import Button from "./Button";
import Icon from "./Icon";
import Separator from "./Separator";

const mainClass = "syndicated-cobrowse";
const interactiveContainerClass = `${mainClass}__interactive-container`;

const CoBrowse = ({
	title,
	description,
	primaryButton,
	primaryButtonAnalyticsLinkId,
	secondaryButton,
	secondaryButtonAnalyticsLinkId,
	footer,
	inputLabel,
	inputPlaceholder,
	errorLabel,
}) => {
	const [code, setCode] = useState("");
	const [error, setError] = useState(false);

	const { setModal } = useContext(Context);

	const submitCode = () => {
		if (code) {
			setError(false);
		} else {
			setError(true);
			return;
		}
		window?.lpTag?.taglets?.cobrowse?.loadApi(function (visitorApi) {
			window?.console.log("CoBrowse visitor API loaded");
			visitorApi.once("sessionRejected", function () {
				window?.console.log("Session rejected");
				setError(true);
			});

			visitorApi.once("sessionOffered", function (event) {
				window?.console.log(
					"Agent answered the request and offers a CoBrowse session"
				);
				visitorApi.acceptSupportOffer(event);
				setModal(false);
			});

			function sessionReadyCallback(startEvent) {
				if (startEvent) {
					window?.console.log("Session is ready and will be started shortly.");
				}
				setModal(false);
			}

			visitorApi.requestSupport({ serviceId: code }, sessionReadyCallback);
		});
	};

	return (
		<div className={mainClass}>
			<h4 className={`${mainClass}__title`}>{title}</h4>
			<div
				className={`${mainClass}__content`}
				dangerouslySetInnerHTML={{ __html: description }}
			/>
			<Separator />
			{error && (
				<div className={`${mainClass}__error`}>
					<Icon icon="alert" />
					<span>{errorLabel}</span>
				</div>
			)}
			<div className={`${interactiveContainerClass}`}>
				<div className={`${interactiveContainerClass}__form`}>
					<label
						htmlFor="txtCoBrowseCode"
						className={`${interactiveContainerClass}__form__label${
							error ? ` ${interactiveContainerClass}__form__label--error` : ""
						}`}
					>
						{inputLabel}
					</label>
					<input
						type="text"
						id="txtCoBrowseCode"
						className={`${interactiveContainerClass}__form__input${
							error ? ` ${interactiveContainerClass}__form__input--error` : ""
						}`}
						name=""
						placeholder={inputPlaceholder}
						maxLength="50"
						autoComplete="off"
						value={code}
						autoFocus
						onChange={(event) => setCode(event.target.value)}
					/>
				</div>
				<div className={`${interactiveContainerClass}__buttons`}>
					<Button
						onClick={() => setModal(false)}
						secondary
						title={secondaryButton}
						analyticsLinkId={secondaryButtonAnalyticsLinkId}
					/>
					<Button
						onClick={submitCode}
						title={primaryButton}
						analyticsLinkId={primaryButtonAnalyticsLinkId}
					/>
				</div>
			</div>
			<Separator />
			<div
				className={`${mainClass}__footer`}
				dangerouslySetInnerHTML={{ __html: footer }}
			/>
		</div>
	);
};

export default CoBrowse;
